// extracted by mini-css-extract-plugin
export default {"main":"AppRouter_main__y-vHn"};